<nav aria-label="breadcrumbs" class="lesson-card-breadcrump__nav">
  <ol class="lesson-card-breadcrump__nav__list">
    @if (fields.concepts) {
      <li class="lesson-card-breadcrump__nav__item">
        @for (concept of fields.concepts; track concept; let index = $index) {
          <a
            class="lesson-card-breadcrump__nav__link"
            [routerLink]="['/lessons/list/search']"
            [queryParams]="{usage: fields.usages, concepts: concept.id }" [attr.id]="target + '-' + index">
            <span
            class="lesson-card-breadcrump__nav__item__name">{{ concept.label }}</span>
            @if (index !== fields.concepts.length - 1) {
              <span class="lesson-card-breadcrump__nav__word__separator"
              aria-hidden="true">,</span>
            }
          </a>
        }
      </li>
    }
    @if (fields.chapters) {
      <li class="lesson-card-breadcrump__nav__item">
        @if (fields.concepts) {
          <span class="lesson-card-breadcrump__nav__item__separator"
          aria-hidden="true">/</span>
        }
        @for (chapter of fields.chapters; track chapter; let index = $index) {
          <a
            class="lesson-card-breadcrump__nav__link"
            [routerLink]="['/lessons/list/search']"
            [queryParams]="{usage: fields.usages, chapters: chapter.id }">
            <span
            class="lesson-card-breadcrump__nav__item__name">{{ chapter.label }}</span>
            @if (index !== fields.chapters.length - 1) {
              <span class="lesson-card-breadcrump__nav__word__separator"
              aria-hidden="true">,</span>
            }
          </a>
        }
      </li>
    }
    @if (fields.skills) {
      <li class="lesson-card-breadcrump__nav__item">
        @if (fields.concepts || fields.chapters) {
          <span class="lesson-card-breadcrump__nav__item__separator"
          aria-hidden="true">/</span>
        }
        @for (skill of fields.skills; track skill; let index = $index) {
          <a
            class="lesson-card-breadcrump__nav__link"
            [routerLink]="['/lessons/list/search']"
            [queryParams]="{usage: fields.usages, skills: skill.id }">
            <span class="lesson-card-breadcrump__nav__item__name">{{ skill.label }}</span>
            @if (index !== fields.skills.length - 1) {
              <span class="lesson-card-breadcrump__nav__word__separator"
              aria-hidden="true">,</span>
            }
          </a>
        }
      </li>
    }
  </ol>
</nav>